$(document).ready(function(){

    function updateCartDrawer() {
        $.ajax({
            type: 'GET',
            url: '/cart',
            success: function(data) {
                // Replace the inner content of the cart drawer
                $('.drawer__inner').html($(data).find('.drawer__inner').html());
            },
            error: function(error) {
                console.error('Error updating cart drawer:', error);
            }
        });
    }
    
    // Add Gifts to Cart
    $('.drawer__inner').on('click', '.drawer__products-offered-block .product-offered-item__add', function(e){
        e.preventDefault();
        
        let product_id = $(this).closest('.cart-products-offered').find('.product-offered-item').data('product-offered');
    
        if (product_id) {
            $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                dataType: 'json',
                data: {
                    id: product_id,
                    quantity: 1
                },
                success: function(response) {
                    updateCartDrawer(); // Refresh the cart drawer
                },
                error: function(error) {
                    console.error('Error adding product:', error);
                }
            });
        }
    });
    
    // Remove Product from Cart (delegated event)
    $('.drawer__inner').on('click', '.cart-remove-button', function(e){
        e.preventDefault();
        
        let product_id = $(this).data('variant-id'); // Assuming the remove button has a data attribute for product ID
        
        $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            dataType: 'json',
            data: {
                id: product_id,
                quantity: 0
            },
            success: function(response) {
                console.log('Product removed from cart:', response);
                updateCartDrawer(); // Refresh the cart drawer
            },
            error: function(error) {
                console.error('Error removing product:', error);
            }
        });
    });
    
    // Update Quantity in Cart (delegated event)
    $('.drawer__inner').on('change', '.quantity__input', function(e){
        let product_id = $(this).data('quantity-variant-id'); // Assuming the quantity input has a data attribute for product ID
        let new_quantity = $(this).val();
    
        $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            dataType: 'json',
            data: {
                id: product_id,
                quantity: new_quantity
            },
            success: function(response) {
                updateCartDrawer(); // Refresh the cart drawer
            },
            error: function(error) {
                console.error('Error updating quantity:', error);
            }
        });
    });

});

